import { getFocusStyles, withTheming, Shape, Spacing, BorderWidth } from '@doordash/design-language';
import styled from 'styled-components';
import { getTagPadding } from './utils.js';

var IconButtonWrapper = styled.button.withConfig({
  displayName: "styles__IconButtonWrapper",
  componentId: "sc-gpd8qq-0"
})(["border:none;cursor:pointer;user-select:none;text-decoration:none;text-align:center;position:relative;max-width:100%;margin:0;padding:0;display:flex;align-items:center;justify-content:center;background-color:transparent;&:focus{", "}"], getFocusStyles());
var IconWrapper = styled.div.withConfig({
  displayName: "styles__IconWrapper",
  componentId: "sc-gpd8qq-1"
})(["display:flex;align-items:center;justify-content:center;"]);
var TagWrapper = withTheming(styled.div.withConfig({
  displayName: "styles__TagWrapper",
  componentId: "sc-gpd8qq-2"
})(["background-color:", ";border-radius:", "px;box-shadow:", ";display:inline-flex;height:", "px;padding:", ";max-width:100%;"], function (props) {
  return function (_ref) {
    var theme = _ref.theme;
    return theme.Colors[props.backgroundColor];
  };
}, function (props) {
  return function (_ref2) {
    var theme = _ref2.theme;
    return theme.Shape.TagDefault === Shape.Pill ? theme.Size["Tag".concat(props.size)] * 2 : Spacing.XxxSmall;
  };
}, function (props) {
  return function (_ref3) {
    var theme = _ref3.theme;
    return "inset 0 0 0 ".concat(BorderWidth.Default, "px ").concat(theme.Colors[props.borderColor]);
  };
}, function (props) {
  return function (_ref4) {
    var theme = _ref4.theme;
    return theme.Size["Tag".concat(props.size)];
  };
}, function (props) {
  return getTagPadding(props);
}));

export { IconButtonWrapper, IconWrapper, TagWrapper };
